import { render, staticRenderFns } from "./ProposalRemote.vue?vue&type=template&id=58eac44e"
import script from "./ProposalRemote.vue?vue&type=script&lang=js"
export * from "./ProposalRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports